import { IoMdClose } from "react-icons/io";
import { AnimatePresence, motion } from "framer-motion";
import NavItems from "./NavItems";
import {useNavigate} from "react-router-dom";
import { User } from 'lucide-react'
import { useAuth } from '../../Context/AuthContext'

function SideBar({ closeMenu, page, handleLogOut }) {
    const navigate = useNavigate();
    const {auth} = useAuth()
    const backdropVariant = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { duration: 0.3 }
        },
        exit: {
            opacity: 0,
            transition: { duration: 0.3 }
        }
    };
    
    const sidebarVariant = {
        hidden: { x: "-100%" },
        visible: {
            x: 0,
            transition: { duration: 0.4, ease: "easeOut" }
        },
        exit: {
            x: "-100%",
            transition: { duration: 0.3, ease: "easeIn" }
        }
    };
    
    return (
        <AnimatePresence>
            <motion.div
                className="fixed inset-0 bg-black bg-opacity-50 z-30"
                variants={backdropVariant}
                initial="hidden"
                animate="visible"
                exit="exit"
                onClick={closeMenu}
            >
                <motion.div
                    className="fixed top-0 left-0 h-screen w-3/4 max-w-xs bg-base-200 z-40 shadow-xl flex flex-col"
                    variants={sidebarVariant}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="flex justify-end p-4">
                        <button
                            className="btn btn-ghost btn-circle"
                            onClick={closeMenu}
                            aria-label="Close menu"
                        >
                            <IoMdClose className="h-6 w-6" />
                        </button>
                    </div>
                    
                    <div className="flex flex-col items-center px-4 flex-1 gap-2">
                        <NavItems isMobile={true} page={page} />
                    </div>
                    
                    {!auth.id && !auth.role && (
                        <div className="flex flex-col w-full p-4 gap-3">
                            <button
                                className="btn btn-primary w-full"
                                onClick={() => navigate("/login")}
                            >
                                Login
                            </button>
                            <button
                                className="btn btn-outline btn-secondary w-full"
                                onClick={() => navigate("/signup")}
                            >
                                Signup
                            </button>
                        </div>
                    )}
                    
                    {auth.id && auth.role && (
                        <div className="flex flex-col w-full p-4 gap-3">
                            <button
                                className="btn btn-primary w-full"
                                onClick={() => navigate("/dashboard")}
                            >
                                <User className="w-5 h-5 mr-2" />
                                Dashboard
                            </button>
                            <button
                                className="btn btn-outline btn-secondary w-full"
                                onClick={() => handleLogOut()}
                            >
                                Sign Out
                            </button>
                        </div>
                    )}
                </motion.div>
            </motion.div>
        </AnimatePresence>
    );
}

export default SideBar;